import Center from "@/Components/Base/Center";
import Icon from "@/Components/Icon/Icon";
import IconButton from "@/Components/IconButton/IconButton";
import Tooltip from "@/Components/Tooltip/Tooltip";
import useBranch from "@/shared/atoms/useBranch";
import useCommon from "@/shared/hooks/useCommon";
import useFormules from "@/shared/hooks/useFormules";
import Formule from "./Formule";
import useIsLiveMerge from "./useIsLiveMerge";
import { cn } from "@/shared/utils/cn";

const Formules = () => {
  const [isMerge, setMerge] = useIsLiveMerge();
  const [local] = useBranch();
  const branches = useFormules();
  const t = useCommon();
  const formuleIds = branches?.map((branch) => branch.branch.id) ?? [];

  if (formuleIds?.includes(local?.id) === false) {
    return null;
  }

  return (
    branches.length > 1 && (
      <>
        <div
          className="relative flex flex-[0_1_auto] items-center py-2"
          data-tour="live-orders.formules-merge"
        >
          <Tooltip content={t("mergeBranches")}>
            <div>
              <Center
                className={cn(
                  "size-24 md:size-28 cursor-pointer mr-1 whitespace-nowrap p-0.5 rounded-full",
                  isMerge ? "bg-primary text-white" : "bg-white"
                )}
                onClick={() => setMerge(true)}
              >
                <Icon
                  className={`h-12 w-12 ${!isMerge ? "fill-primary" : "fill-white"}`}
                  variants="link"
                />
              </Center>
            </div>
          </Tooltip>
          {isMerge && (
            <div className="absolute -top-4 right-0 z-2">
              <IconButton
                onClick={() => setMerge(false)}
                size="small"
                variant="danger"
                variants="times"
              />
            </div>
          )}
        </div>

        {!isMerge && (
          <div
            className="flex flex-1 overflow-x-auto py-2 overscroll-x-auto"
            data-tour="live-orders.formules"
          >
            {branches?.map((branch) => {
              const isActive = branch.branch.id === local.id;
              return (
                <Formule
                  branch={branch}
                  key={branch.branch.id}
                  isActive={isActive}
                />
              );
            })}
          </div>
        )}
      </>
    )
  );
};

export default Formules;
